import type { DidDisconnectAnonStatusDatagramBuf } from "~/classes/generated/status"

import { parseAnonymousIdBuf } from "~/utils/flatbuffers/anonymous"

const console = useLogger("status/disconnect-anon")

export function handleDidDisconnectAnonStatusDatagramBuf(buf: DidDisconnectAnonStatusDatagramBuf) {
  const { emitInterfaceEvent } = useEvents()
  const { cacheState } = useCache()

  const datagram: DidDisconnectAnonStatusDatagram = {
    anonId: parseAnonymousIdBuf(buf.anonId()!),
  }
  console.info("Disconnected anonymous cache connection")
  cacheState.value.status = "offlineAnon"
  cacheState.value.anonId = datagram.anonId
  cacheState.value.userId = undefined
  cacheState.value.nextReconnectDate = undefined
  // Do any client login tasks, e.g. subscriptions?

  emitInterfaceEvent("didDisconnectAnonStatus", datagram)
}
